module.exports = __webpack_public_path__ + "assets/img/Reisegutschein.ec107d17.jpg";